import React, { createContext } from 'react';

export const StudentStateContext = createContext<any>(null);
